import {useEffect, useState} from "react";
import MainLayout from "../components/MainLayout";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {Pencil, Printer, Trash2} from "lucide-react";
import {useNavigate} from "react-router-dom";
import {Dialog} from "primereact/dialog";
import {toast} from "react-toastify";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import {BreadCrumb} from "primereact/breadcrumb";
import {logoBase64} from "../utils/utils";
import moment from "moment";
import "moment/locale/uz";
import {
	deleteInvoice,
	getInvoices,
	getNakladnoySerialsById,
} from "../services/invoice.service";

moment.locale("uz");

pdfMake.vfs = pdfFonts.vfs;

const InvoicesPage = () => {
	const [showDialog, setShowDialog] = useState(false);
	const [invoices, setInvoices] = useState([]);
	const [searchText, setSearchText] = useState("");
	const [selectedInvoice, setSelectedInvoice] = useState();
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	const fetchInvoices = async () => {
		setLoading(true);
		try {
			const invoices = await getInvoices();
			setInvoices(invoices);
		} catch (error) {
			console.error("Error fetching invoices", error);
			toast.error("Накладной юклашда хатолик");
		} finally {
			setLoading(false);
		}
	};

	const filteredData = invoices
		.filter((item) => {
			const query = searchText.toLowerCase();

			const idMatch = item.id.toString().includes(query);

			const demandMatch = item.demands?.some((d) =>
				d.toLowerCase().includes(query)
			);

			return idMatch || demandMatch;
		})
		.reverse();

	const handleDelete = async () => {
		try {
			await deleteInvoice(selectedInvoice.id);
			toast.success("Накладной муваффақиятли ўчирилди");
			setShowDialog(false);
			fetchInvoices();
		} catch (error) {
			console.error("Error deleting item", error);
		}
	};

	const handleDeleteSelection = async (rowData) => {
		setShowDialog(true);
		setSelectedInvoice(rowData);
	};

	const handleEdit = (rowData) => {
		navigate("/invoice-creation", {state: {invoice: rowData}});
	};

	const getSehName = (sehId) => {
		const sehNames = {
			45: "Мягкий 1",
			64: "Мягкий 2",
			46: "Упаковка",
		};
		return sehNames[sehId] || "";
	};

	const handlePrint = async (rowData) => {
		const newWindow = window.open("", "_blank");
		newWindow.document.write(`
      <html>
        <head><title>Loading...</title></head>
        <body style="font-family:sans-serif;text-align:center;padding-top:50px;">
          <h2>Загрузка данных...</h2>
        </body>
      </html>
    `);

		const vipusks = await getNakladnoySerialsById(rowData.id);

		// Replace incorrect amounts from API (getNakladnoySerialsById) response with the correct values from rowData
		// const printData = vipusks;
		const printData = vipusks.map((item) => {
			const correct = rowData.nakladnoy_uniques.find(
				(u) => u.unique_id === item.unique_id
			);
			return correct ? {...item, amount: correct.amount} : item;
		});

		const sehId = sessionStorage.getItem("sehId");
		const sehName = getSehName(Number(sehId));

		const docDefinition = {
			content: [
				{
					image: logoBase64,
					width: 100,
					alignment: "left",
					margin: [0, 0, 0, 10],
				},
				{
					text: "Накладной",
					style: {
						fontSize: 32,
						bold: true,
					},
					margin: [0, -40, 0, 65],
				},
				{
					columns: [
						{
							text: sehName,
							alignment: "left",
						},
						{
							text: moment(rowData.date).format("D MMMM YYYY"),
						},
						{
							text: `№_${rowData.doc_no}`,
							alignment: "right",
						},
					],
					margin: [0, 0, 0, 42],
				},
				{
					table: {
						headerRows: 1,
						widths: ["*", "auto", "auto", "auto", "auto", "auto", "auto"],
						body: [
							[
								"Наименования",
								"Уник.№",
								"Щтук",
								"Упк сони",
								"Ойна",
								"Ойна река",
								"Лхдф",
							],
							...printData?.map((item) => [
								`${item.furniture.category?.name} ${item.furniture.komplekt?.name} ${item.furniture.name}`,
								item.demand_furniture_id
									? item.demand_furniture.demand.doc_no
									: item.unique.name,
								item.amount || 0,
								item.unique.package_quantity || 0,
								item.unique.glass_quantity || 0,
								item.unique.glass_wood_quantity || 0,
								item.unique.lxdf_quantity || 0,
							]),
						],
					},
					margin: [0, 5, 0, 5],
				},
				{
					columns: [
						{
							width: "*",
							stack: [
								{text: "imzo", margin: [0, 0, 120, 0]},
								{
									canvas: [
										{type: "line", x1: 0, y1: 0, x2: 70, y2: 0, lineWidth: 1},
									],
								},
							],
						},
						{
							width: "*",
							stack: [
								{text: "imzo", margin: [0, 0, 15, 2]},
								{
									canvas: [
										{
											type: "line",
											x1: 180,
											y1: 0,
											x2: 110,
											y2: 0,
											lineWidth: 1,
										},
									],
								},
							],
						},
					],
					margin: [100, 20, 110, 0],
				},
				{
					text: "",
					margin: [0, 0, 0, 240],
				},
			],
			styles: {
				header: {
					fontSize: 14,
					bold: true,
					alignment: "center",
				},
			},
			defaultStyle: {
				font: "Roboto",
				fontSize: 12,
				alignment: "center",
			},
		};

		pdfMake.createPdf(docDefinition).getBlob((blob) => {
			const url = URL.createObjectURL(blob);
			newWindow.location.href = url;
		});
	};

	useEffect(() => {
		fetchInvoices();
	}, []);

	const item = [
		{
			label: "Накладнойлар",
			template: () => (
				<span className="cursor-pointer" onClick={() => navigate("/invoice")}>
					Накладнойлар
				</span>
			),
		},
	];

	// console.log(filteredData);

	return (
		<MainLayout header="Накладнойлар">
			<div>
				{<BreadCrumb model={item} className="px-0 pt-0 mb-8" />}
				<div className="flex justify-between mb-4">
					<div className="relative flex items-center w-full">
						<i className="absolute text-gray-400 -translate-y-1/2 pointer-events-none pi pi-search left-3 top-1/2" />
						<InputText
							value={searchText}
							onChange={(e) => setSearchText(e.target.value)}
							className="w-full h-10 pt-1 border pl-9"
							placeholder="Накладной ёки заказ рақами..."
						/>
					</div>
					<Button
						icon="pi pi-plus"
						label="Қўшиш"
						className="px-4 text-white min-w-[100px] bg-blue rounded-md hover:bg-opacity-90 w-[200px] ml-4"
						onClick={() => navigate("/invoice-creation")}
					/>
				</div>
				<DataTable
					className="custom-row-border"
					value={filteredData}
					emptyMessage="Накладнойлар йўқ"
					rows={10}
					loading={loading}>
					<Column field="doc_no" header="Накладной рақами" />
					<Column
						field="date"
						header="Накладной санаси"
						body={(rowData) => moment(rowData.date).format("D MMMM YYYY")}
					/>
					<Column
						field="demands"
						header="Заказлар"
						body={(rowData) => {
							const demands = rowData.demands;
							const visible = demands.slice(0, 8);
							const showDots = demands.length > 8;

							return (
								visible
									.map(
										(demand, idx) =>
											demand + (idx < visible.length - 1 ? ", " : "")
									)
									.join("") + (showDots ? "..." : "")
							);
						}}
					/>
					<Column
						field=""
						header="Амал"
						body={(rowData) => (
							<div className="flex justify-between cursor-pointer">
								<Printer onClick={() => handlePrint(rowData)} />
								<Pencil onClick={() => handleEdit(rowData)} />
								<Trash2 onClick={() => handleDeleteSelection(rowData)} />
							</div>
						)}
					/>
				</DataTable>
			</div>
			<Dialog
				visible={showDialog}
				onHide={() => setShowDialog(false)}
				header={
					<div className="text-lg font-semibold text-black">
						Накладнойни очирмокчимисиз
					</div>
				}
				className="border-t-[6px] border-red-600 rounded-md shadow-lg"
				style={{width: "30rem"}}
				footer={
					<div className="flex justify-between mt-4">
						<Button
							label="Бекор килиш"
							icon="pi pi-times"
							className="px-4 py-2 text-black bg-gray-200 hover:bg-gray-300"
							onClick={() => setShowDialog(false)}
						/>
						<Button
							label="Очириш"
							icon="pi pi-trash"
							className="px-4 py-2 text-white bg-red-600 hover:bg-red-700"
							onClick={handleDelete}
						/>
					</div>
				}
			/>
		</MainLayout>
	);
};

export default InvoicesPage;
